import React from 'react';
import './Subscription.scss';
import SubscriptionCard from './SubscriptionCard/SubscriptionCard';
// import SubscriptionImage from '../../../../assets/SubscriptionImage.png';

export default function Subscription() {
  const plans = [
    {
      planName: 'Basic',
      price: 1,
      duration: 'Mon',
      savingsText: '',
      equivalentText: '',
      buttonLabel: 'Avail On App →',
      features: [
        { label: 'No Ads' },
        { label: 'Post Expiry Window 7 Days' },
        { label: 'Can Renew Same Plan' },
        { label: 'Cloud Sync' },
        { label: 'Cloud Storage Upto 5GB' }
      ]
    },
    {
      planName: 'Basic',
      price: 10,
      duration: 'Year',
      savingsText: '★ Save $2!',
      equivalentText: 'Equivalent To $0.83/Month',
      buttonLabel: 'Avail On App →',
      features: [
        { label: 'No Ads' },
        { label: 'Post Expiry Window 7 Days' },
        { label: 'Can Renew Same Plan' },
        { label: 'Cloud Sync' },
        { label: 'Cloud Storage Upto 5GB' }
      ]
    },
    {
      planName: 'Premium',
      price: 2,
      duration: 'Mon',
      savingsText: '',
      equivalentText: '',
      buttonLabel: 'Avail On App →',
      features: [
        { label: 'No Ads' },
        { label: 'Post Expiry Window 30 Days' },
        { label: 'Can Switch Plans' },
        { label: 'Cloud Sync' },
        { label: 'Cloud Storage Upto 50GB' }
      ]
    },
    {
      planName: 'Premium',
      price: 16,
      duration: 'Year',
      savingsText: '★ Save $8!',
      equivalentText: 'Equivalent To $1.33/Month',
      buttonLabel: 'Avail On App →',
      features: [
        { label: 'No Ads' },
        { label: 'Post Expiry Window 30 Days' },
        { label: 'Can Switch Plans' },
        { label: 'Cloud Sync' },
        { label: 'Cloud Storage Upto 50GB' }
      ]
    }
  ];

  return (
    <div className='subscription-container'>
      <div className='subscription-heading-container'>
        <h1>Subscriptions</h1>
        <p>Choose any plan according to your needs and you can cancel subscription anytime you want</p>
      </div>
      <div className='subscription-details-container'>
        {plans.map((plan, index) => (
          <SubscriptionCard
            key={index}
            planName={plan.planName}
            price={plan.price}
            duration={plan.duration}
            savingsText={plan.savingsText}
            equivalentText={plan.equivalentText}
            features={plan.features}
            buttonLabel={plan.buttonLabel}
          />
        ))}
      </div>
    </div>
  )
}
